import { render, staticRenderFns } from "./AdminLicences.vue?vue&type=template&id=02f85ea3&"
import script from "./AdminLicences.vue?vue&type=script&lang=js&"
export * from "./AdminLicences.vue?vue&type=script&lang=js&"
import style0 from "./AdminLicences.vue?vue&type=style&index=0&id=02f85ea3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports